import { render } from "./OrganismsChartSaltos.vue?vue&type=template&id=b9da4e96&scoped=true&ts=true"
import script from "./OrganismsChartSaltos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsChartSaltos.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsChartSaltos.vue?vue&type=style&index=0&id=b9da4e96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9da4e96"],['__file',"src/components/organisms/OrganismsChartSaltos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9da4e96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9da4e96', __exports__)) {
    api.reload('b9da4e96', __exports__)
  }
  
  module.hot.accept("./OrganismsChartSaltos.vue?vue&type=template&id=b9da4e96&scoped=true&ts=true", () => {
    api.rerender('b9da4e96', render)
  })

}


export default __exports__